import React, { FC } from 'react'
import styles from 'styles/utility/text.module.scss'

type Props = {
  label: string
}

const SmallLabel: FC<Props> = (props) => {
  const { label } = props
  return <span className={`${styles.font_xxsmall} ${styles.color_grey_01}`}>{label}</span>
}

export default SmallLabel
